import { Address } from 'viem'
import { getAuthStore } from '@/domains/auth/model/store.ts'
import { AUTH_SIGN_MESSAGE } from '@/domains/auth/config'
import { walletWeb3Provider } from '@/modules/game/shared/lib/sdk/dapp-portal.ts'
import { ethers } from 'ethers'
import { MemberApi } from '@/domains/auth/api'
import { Device } from '@/shared/lib/utils/device.ts'
import { isMobile } from '@lair-finance/device'

export async function login(address: Address) {
  const authStore = getAuthStore()
  authStore.reset()

  const message = AUTH_SIGN_MESSAGE
  const signer = await walletWeb3Provider.getSigner(address)
  const messageBytes = ethers.toUtf8Bytes(message)
  const signature = await signer.signMessage(messageBytes)
  const { nonce } = await MemberApi.fetchNonce({ walletAddress: address })
  const deviceId = Device.get() || Device.create()

  const response = await MemberApi.login({
    walletAddress: address,
    nonce,
    signature,
    message,
    deviceId,
    type: 'METAMASK',
    isMobile: isMobile(),
  })

  authStore.setToken(response.token)
}
